(function () {
  'use strict';
  if (window.KP_BUYBOX_LOADED) return;
  window.KP_BUYBOX_LOADED = true;

  var STORAGE_KEY = 'kp-buybox';
  var state = { packs: 0, plan: 'sub', cad: 0 };

  function wrappers() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-kp-buybox]'));
  }

  function isCad(v) { return v === 30 || v === 60 || v === 90; }

  // Default cadence of a tier: its radio carries the value (every instance
  // agrees). Markup without the attribute derives it from the pack count.
  function cadDefault(packs) {
    var r = document.querySelector('input[data-kp-packs][value="' + packs + '"][data-kp-cad-default]');
    var v = r ? Number(r.getAttribute('data-kp-cad-default')) : 0;
    if (isCad(v)) return v;
    return packs === 1 ? 30 : packs === 3 ? 60 : 90;
  }

  // Only the control itself; the pre-rendered cadence words are spans that
  // carry a value in the same attribute.
  function cadFieldset(bb) { return bb.querySelector('fieldset[data-kp-cad]'); }

  function readInitial(bb) {
    var p = bb.querySelector('input[data-kp-packs]:checked');
    var pl = bb.querySelector('input[data-kp-plan]:checked');
    var c = bb.querySelector('input[data-kp-cad-radio]:checked');
    var packs = p ? Number(p.value) : 0;
    var cad = 0;
    if (c) cad = Number(c.value);
    else if (p && p.getAttribute('data-kp-cad-default')) cad = Number(p.getAttribute('data-kp-cad-default'));
    if (!isCad(cad)) cad = cadDefault(packs || 1);
    return { packs: packs, plan: pl ? pl.value : 'sub', cad: cad };
  }

  // A stored cadence survives only while a radio offers it (a selling plan can
  // be absent); with no control anywhere the stored value is harmless.
  function storedCad(bb, raw, packs) {
    var v = Number(raw);
    if (isCad(v)) {
      var sel = 'input[data-kp-cad-radio][value="' + v + '"]';
      if (bb.querySelector(sel) || document.querySelector(sel)) return v;
      if (!document.querySelector('input[data-kp-cad-radio]')) return v;
    }
    return cadDefault(packs);
  }

  function readStored(bb) {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || typeof v.packs !== 'number') return null;
      if (!bb.querySelector('input[data-kp-packs][value="' + v.packs + '"]')) return null;
      if (v.plan !== 'sub' && v.plan !== 'once') return null;
      if (v.plan === 'sub' && !bb.querySelector('input[data-kp-plan][value="sub"]')) return null;
      return { packs: v.packs, plan: v.plan, cad: storedCad(bb, v.cad, v.packs) };
    } catch (e) { return null; }
  }

  function store() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* private mode */ }
  }

  // The closer instance renders no tier radios, so fall back to any instance
  // that does: the selling plan of the selected tier is the same everywhere.
  function packsRadio(bb) {
    var sel = 'input[data-kp-packs][value="' + state.packs + '"]';
    return (bb && bb.querySelector(sel)) || document.querySelector(sel);
  }

  // The plan id of a cadence: the root carries one per cadence; markup without
  // them carries only the tier's own plan id on its radio.
  function planIdFor(bb, cad) {
    var root = bb || document.querySelector('[data-kp-buybox]');
    var id = root ? root.getAttribute('data-kp-plan-' + cad) : '';
    if (id) return id;
    var r = packsRadio(bb);
    return (r && r.getAttribute('data-kp-plan-id')) || '';
  }

  // What goes in `quantity`: the shipped pack count, or the paid count once the
  // store posts the bonus lines itself (data-kp-post="paid"); one-time orders
  // keep the shipped count, the cart rule prices them.
  function postQty(bb) {
    if (bb && state.plan === 'sub' && bb.getAttribute('data-kp-post') === 'paid') {
      var r = packsRadio(bb);
      var paid = r ? Number(r.getAttribute('data-kp-paid')) : 0;
      if (paid > 0) return paid;
    }
    return state.packs;
  }

  function applyTo(bb) {
    var localRadio = bb.querySelector('input[data-kp-packs][value="' + state.packs + '"]');
    var planRadio = bb.querySelector('input[data-kp-plan][value="' + state.plan + '"]');
    if (localRadio && !localRadio.checked) localRadio.checked = true;
    if (planRadio && !planRadio.checked) planRadio.checked = true;
    bb.classList.toggle('is-sub', state.plan === 'sub');
    bb.classList.toggle('is-once', state.plan !== 'sub');
    bb.setAttribute('data-kp-tier-on', String(state.packs));
    bb.setAttribute('data-kp-cad-on', String(state.cad));
    var cadRadio = bb.querySelector('input[data-kp-cad-radio][value="' + state.cad + '"]');
    if (cadRadio && !cadRadio.checked) cadRadio.checked = true;
    // Progressive enhancement: the control ships hidden, JS reveals it.
    var cadBox = cadFieldset(bb);
    if (cadBox && cadBox.hasAttribute('hidden') && bb.querySelector('input[data-kp-plan][value="sub"]')) {
      cadBox.removeAttribute('hidden');
    }
    var qty = bb.querySelector('[data-kp-qty]');
    var sp = bb.querySelector('[data-kp-selling-plan]');
    if (qty) qty.value = String(postQty(bb));
    if (sp) sp.value = state.plan === 'sub' ? planIdFor(bb, state.cad) : '';
  }

  function setState(patch) {
    if (typeof patch.packs === 'number' && patch.packs > 0) state.packs = patch.packs;
    if (patch.plan === 'sub' || patch.plan === 'once') state.plan = patch.plan;
    if (isCad(Number(patch.cad))) state.cad = Number(patch.cad);
    wrappers().forEach(applyTo);
    store();
    document.dispatchEvent(new CustomEvent('kp-buybox:change', { detail: { packs: state.packs, plan: state.plan, cad: state.cad } }));
  }

  function showError(bb, message) {
    var el = bb.querySelector('[data-kp-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function hideError(bb) {
    var el = bb.querySelector('[data-kp-error]');
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  // The gift tier adds the $0 gift product as a one-time line and keeps it at
  // quantity 1: read the cart, add the line only when it is missing, then
  // clamp it (update.js only changes lines that exist, it never adds one).
  // A store-side gift rule may add the same line; the clamp covers that too.
  // Never blocks the main add.
  function giftVariant(bb) {
    var id = Number(bb.getAttribute('data-kp-gift-variant'));
    if (!id) return 0;
    var r = packsRadio(bb);
    return r && r.getAttribute('data-kp-gift') === '1' ? id : 0;
  }

  function cartJson(url, body) {
    var opts = body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    } : { headers: { 'Accept': 'application/json' } };
    return fetch(url, opts).then(function (res) { return res.json(); });
  }

  function giftQty(cart, id) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i].variant_id === id) return items[i].quantity;
    return 0;
  }

  function pinGift(bb, addUrl) {
    var id = giftVariant(bb);
    if (!id) return Promise.resolve();
    var cartUrl = bb.getAttribute('data-kp-cart-url') || '/cart';
    var updateUrl = bb.getAttribute('data-kp-update-url') || '/cart/update';
    if (updateUrl.indexOf('.js') === -1) updateUrl += '.js';
    var readUrl = cartUrl.replace(/\/$/, '') + '.js';
    var updates = {};
    updates[id] = 1;
    var main = Number(bb.getAttribute('data-kp-variant'));
    return cartJson(readUrl).then(function (cart) {
      // No main line in the cart (the add failed or has not landed): no gift.
      if (main && giftQty(cart, main) === 0) return null;
      var q = giftQty(cart, id);
      if (q === 1) return null;
      if (q === 0) return cartJson(addUrl, { items: [{ id: id, quantity: 1 }] }).then(function () { return cartJson(readUrl); });
      return cart;
    }).then(function (cart) {
      if (cart && giftQty(cart, id) > 1) return cartJson(updateUrl, { updates: updates });
    }).catch(function () { /* the gift is a bonus: a failed add never blocks the order */ });
  }

  function addToCart(bb) {
    var btn = bb.querySelector('[data-kp-atc]');
    var variant = Number(bb.getAttribute('data-kp-variant'));
    var addUrl = bb.getAttribute('data-kp-add-url') || '/cart/add';
    var cartUrl = bb.getAttribute('data-kp-cart-url') || '/cart';
    if (!variant) { showError(bb, 'This product is not available right now.'); return; }
    if (addUrl.indexOf('.js') === -1) addUrl += '.js';

    var planId = state.plan === 'sub' ? Number(planIdFor(bb, state.cad)) : 0;
    var item = { id: variant, quantity: postQty(bb) };
    if (planId) item.selling_plan = planId;

    hideError(bb);
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; });
    }).then(function (r) {
      if (!r.ok) {
        showError(bb, (r.json && (r.json.description || r.json.message)) || 'Could not add to cart. Please try again.');
        return;
      }
      return pinGift(bb, addUrl).then(function () { return r; });
    }).then(function (r) {
      if (!r) return;
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') {
        window.upcartOpenCart();
      } else {
        window.location.href = cartUrl;
      }
    }).catch(function () {
      showError(bb, 'Could not add to cart. Please try again.');
    }).then(function () {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
  }

  function bind(bb) {
    if (bb.getAttribute('data-kp-bound') === '1') return;
    bb.setAttribute('data-kp-bound', '1');

    bb.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT') return;
      if (t.hasAttribute('data-kp-packs')) {
        // A tier change resets the cadence to that tier's own span
        // (Marcelo, 11 Sep, final: 1 pack 30 d, 2 paid 60 d, 3 paid 90 d).
        var packs = Number(t.value);
        setState({ packs: packs, cad: cadDefault(packs) });
      } else if (t.hasAttribute('data-kp-cad-radio')) setState({ cad: Number(t.value) });
      else if (t.hasAttribute('data-kp-plan')) setState({ plan: t.value });
    });

    var form = bb.querySelector('[data-kp-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(bb);
      });
      // Only the hero posts; the lower boxes' buttons are links back to it.
      var atc = bb.getAttribute('data-kp-instance') === 'hero' ? form.querySelector('button[type="submit"][data-kp-atc]') : null;
      if (atc) atc.addEventListener('click', function () { armGift(bb); });
    }
  }

  // In production the UpCart embed takes the form submit before our handler
  // (document-level capture listener, see the runbook), so addToCart() and
  // its pinGift() never run. The gift is then added here, after UpCart's own
  // add: armGift() marks the box that is about to post, UpCart's public
  // added-to-cart callback (or a timed fallback) pins the gift. pinGift() is
  // idempotent, so a double trigger costs one cart read. Scoped to this
  // template's buy box; nothing here changes UpCart or other products.
  var armedGift = null;
  var armedTimer = 0;
  var upcartHooked = false;
  function settleGift() {
    var bb = armedGift;
    if (!bb) return;
    armedGift = null;
    clearTimeout(armedTimer);
    var addUrl = bb.getAttribute('data-kp-add-url') || '/cart/add';
    if (addUrl.indexOf('.js') === -1) addUrl += '.js';
    pinGift(bb, addUrl).then(function () {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    });
  }
  function armGift(bb) {
    if (!giftVariant(bb)) return;
    armedGift = bb;
    clearTimeout(armedTimer);
    armedTimer = setTimeout(settleGift, 3000);
    if (!upcartHooked && typeof window.upcartSubscribeAddedToCart === 'function') {
      upcartHooked = true;
      window.upcartSubscribeAddedToCart(function () { settleGift(); });
    }
  }

  // The $0 gift line is a normal cart line, so the drawer's stepper can raise
  // it. While the shopper is on this page, every UpCart cart update clamps the
  // gift back to 1 (idempotent: a cart at 1 is left alone, so our own update
  // does not loop). Nothing outside this template's JS is involved.
  var clampInited = false;
  var clampBusy = false;
  function clampGift() {
    if (clampBusy) return;
    var bb = document.querySelector('[data-kp-buybox][data-kp-gift-variant]');
    var id = bb ? Number(bb.getAttribute('data-kp-gift-variant')) : 0;
    if (!id) return;
    var cartUrl = bb.getAttribute('data-kp-cart-url') || '/cart';
    var updateUrl = bb.getAttribute('data-kp-update-url') || '/cart/update';
    if (updateUrl.indexOf('.js') === -1) updateUrl += '.js';
    clampBusy = true;
    cartJson(cartUrl.replace(/\/$/, '') + '.js').then(function (cart) {
      if (giftQty(cart, id) <= 1) return null;
      var updates = {};
      updates[id] = 1;
      return cartJson(updateUrl, { updates: updates }).then(function () {
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      });
    }).catch(function () {}).then(function () { clampBusy = false; });
  }
  function initClamp() {
    if (clampInited) return;
    var tries = 0;
    (function hook() {
      if (typeof window.upcartSubscribeCartUpdated === 'function') {
        clampInited = true;
        window.upcartSubscribeCartUpdated(function () { clampGift(); });
        return;
      }
      if (tries++ < 40) setTimeout(hook, 500);
    })();
  }

  var stickyInited = false;
  function initSticky() {
    if (stickyInited) return;
    var bar = document.querySelector('[data-kp-sticky]');
    if (!bar) return;
    stickyInited = true;
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-kp-atc]'));
    var heroBtn = targets[0];
    var visible = new Set();
    var raf = 0;

    function evaluate() {
      raf = 0;
      var heroPassed = heroBtn ? heroBtn.getBoundingClientRect().bottom < 0 : false;
      var show = window.innerWidth < 900 && heroPassed && visible.size === 0;
      if (show) {
        bar.hidden = false;
        bar.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () { bar.classList.add('is-on'); });
      } else {
        bar.classList.remove('is-on');
        bar.setAttribute('aria-hidden', 'true');
        bar.hidden = true;
      }
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(evaluate); }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
        schedule();
      }, { threshold: 0 });
      targets.forEach(function (t) { io.observe(t); });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    var stickyBtn = bar.querySelector('[data-kp-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('[data-kp-form]');
        if (!form) return;
        var bb = form.closest('[data-kp-buybox]');
        if (bb) armGift(bb);
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
    schedule();
  }

  function init() {
    var all = wrappers();
    if (!all.length) return;
    if (!state.packs) {
      var first = all[0];
      var stored = readStored(first);
      var initial = stored || readInitial(first);
      state.packs = initial.packs || 1;
      state.plan = initial.plan;
      state.cad = isCad(initial.cad) ? initial.cad : cadDefault(state.packs);
    }
    all.forEach(bind);
    wrappers().forEach(applyTo);
    store();
    initSticky();
    initClamp();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
